import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import '../../styles/core.scss';
import css from './points-display.scss';

/**
 * Points Display Component for Live Maths and Activity
 * Displays points earned by the student for a selected date
 */

const PointsDisplay = ({ imgSrc, title, points, elementStyle }) => (
    <div className={css.component}>
        <div className={`${css[elementStyle]} ${css.logo}`}><Isvg src={imgSrc} /></div>
        <div className={css.pointdetails}>
            <div className={css.points}>{points.toLocaleString('en-AU')}</div>
            <div className={css.title}>{title}</div>
        </div>
    </div>
);

PointsDisplay.propTypes = {
    imgSrc: PropTypes.string,
    title: PropTypes.string,
    points: PropTypes.number,
    elementStyle: PropTypes.string
};

export default styleable(css)(PointsDisplay);



// WEBPACK FOOTER //
// ./components/points-display/points-display.js